import React from 'react'

export default function TrackerMap({ tracker }) {
  return (
    <div className="tracker__map"><img src={tracker.map.publicURL} alt='map' /></div>
  )
}
